import { useI18n } from '../../../i18n/useI18n';
import { useToast } from '../../../toast/useToast';
import { LiksToast } from './LiksToast';
import './LiksToaster.css';

export function LiksToaster() {
  const { translate } = useI18n();
  const { activeToasts, exitingIds, dismissToast, completeDismiss } =
    useToast();
  const latestToast = activeToasts.at(-1);
  const announcement =
    latestToast === undefined
      ? ''
      : latestToast.description != null && latestToast.description !== ''
        ? `${latestToast.title}. ${latestToast.description}`
        : latestToast.title;

  if (activeToasts.length === 0) {
    return null;
  }

  return (
    <section
      className="liks-toaster"
      role="region"
      aria-label={translate('toast.regionLabel')}
    >
      <p
        className="liks-toaster__announcement"
        aria-live="polite"
        aria-atomic="true"
      >
        {announcement}
      </p>

      <div className="liks-toaster__stack">
        {activeToasts.map((toast) => (
          <LiksToast
            key={toast.id}
            toast={toast}
            isExiting={exitingIds.includes(toast.id)}
            dismissLabel={translate('toast.dismiss')}
            onDismiss={() => dismissToast(toast.id)}
            onExitComplete={() => completeDismiss(toast.id)}
          />
        ))}
      </div>
    </section>
  );
}
